module.exports = __webpack_public_path__ + "static/img/get_bunnyposy.5a2766d6.png";